export default __webpack_public_path__ + "static/media/blog-img100.cffe5a2e.jpg";